export default function FixedPlanIcon({ size = 18 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M7 10V7a5 5 0 0 1 10 0v3" />
      <rect x="4" y="10" width="16" height="12" rx="2.5" />
      <path d="m12 12.5 1.05 2.1 2.32.34-1.68 1.63.4 2.3L12 17.78l-2.09 1.1.4-2.31-1.68-1.63 2.32-.34z" fill="currentColor" stroke="none" />
    </svg>
  );
}
